(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/View', 'templates'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    var templates = {
      secureMessageIdTemplate: require('./secureMessageIdTemplate.hbs')
    };
    module.exports = factory(require('backbone-torso/modules/View'), templates);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(TorsoView, templates) {
  'use strict';

  var TEMPLATE_MAP = {
    defaultTemplate: templates.secureMessageIdTemplate
  };

  /**
   * @class  SecureMessageDefaultView
   * @constructor
   * @param option {Object}
   *   @param options.model {Torso.Model}
   */
  return  TorsoView.extend({
    tagName: 'li',

    /**
     * @override
     * @method prerender
     */
    prerender: function() {
      this._updateTemplateFromModel();
    },

    /**
     * Updates the template of this view based on the model type property.
     * @private
     * @method _updateTemplateFromModel
     */
    _updateTemplateFromModel: function() {
      var messageType = this.model && this.model.get('type');
      this.template = TEMPLATE_MAP[messageType] || TEMPLATE_MAP.defaultTemplate;
    }
  });
}));
